module.exports = __webpack_public_path__ + "img/logo.a8755857.png";